module.exports = __webpack_public_path__ + "img/shuibeng1.2da00451.gif";